/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'ragged',
    quality: 0,
    toughness: -1,
    armorClass: -2
}